export const INITIAL = {
	MODAL: {
		content: '',
		data: {},
	},
	VALUES: {
		name: '',
		description: '',
		strength: 0,
		dexterity: 0,
		constitution: 0,
		intelligence: 0,
		wisdom: 0,
		charisma: 0,
	},
	LIST: {
		columns: {
			name: 'Nome',
			description: 'Descrição',
			modifier: 'Modificador',
		},
		rows: []
	},
}